import { Controller } from "@hotwired/stimulus"
import { get, FetchRequest } from '@rails/request.js'
import Swal from 'sweetalert2'
import { breadcrumbs_buttons_tasks_path } from '../routes'

export default class extends Controller {
  static values = { buildingComplexId: String }
  static params = ["buildingComplexId"]
  changeTaskView(event) {
    let querystring = [];
    if (document.getElementById("all_tasks").checked) {
      querystring.push("all_tasks=true")
    } else {
      querystring.push("all_tasks=false")
    }

    const currentUrl = window.location.pathname;
    Turbo.visit(currentUrl + '?' + querystring.join('&'), { frame: "table_content" })
  }

  refreshNewTaskButton(event) {
    const buildingComplexId = event.params.buildingComplexId;
    
    const breadcrumbsUrl = breadcrumbs_buttons_tasks_path(buildingComplexId);
    
    fetch(breadcrumbsUrl, {
      headers: {
        'Accept': 'text/html',
      }
    })
    .then(response => response.text())
    .then(html => {
      const breadcrumbsButtonsElement = document.getElementById('breadcrumbs-buttons');
      if (breadcrumbsButtonsElement) {
        breadcrumbsButtonsElement.innerHTML = html;
      }
    })
    .catch(error => {
      console.error('Error refreshing breadcrumbs buttons:', error);
    });
  }

  clearForm() {
    document.getElementById("model_searchform").querySelector("#clear").value = 1;
    document.getElementById("model_searchform").setAttribute("data-turbo", "false");
    document.getElementById("model_searchform").requestSubmit();
  }
}
